// eslint-disable-next-line no-restricted-imports
import { forwardRef } from 'react';
import { Popover as RACPopover, type PopoverProps as RACPopoverProps } from 'react-aria-components';

interface CollapsibleListProps extends Pick<
  RACPopoverProps,
  'placement' | 'offset' | 'crossOffset' | 'maxHeight' | 'children' | 'triggerRef' | 'isNonModal'
> {}

/**
 * Displays a collapsible list activated via a trigger element.
 *
 * @internal
 */
export const CollapsibleList = forwardRef<HTMLDivElement, CollapsibleListProps>(({ children, ...props }, ref) => (
  <RACPopover {...props} ref={ref} className="cim-collapsible-list" containerPadding={16} data-cim-style-root>
    {children}
  </RACPopover>
));

CollapsibleList.displayName = 'CollapsibleList';
